import React from 'react';
import { Droplet, ShieldCheck, Leaf } from 'lucide-react';
export function Methodology() {
  return <section className="py-20 bg-brand-cream" data-id="element-104">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-105">
        <div className="text-center mb-16" data-id="element-106">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-teal mb-4" data-id="element-107">
            El Método de las 3 Etapas
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-108">
            Un proceso biológico, lógico y accesible diseñado para limpiar el
            organismo desde la raíz.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-109">
          {/* Pillar 1 */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-md transition-shadow relative overflow-hidden" data-id="element-110">
            <div className="absolute top-0 right-0 w-24 h-24 bg-blue-50 rounded-bl-full -z-0" data-id="element-111"></div>
            <div className="relative z-10" data-id="element-112">
              <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center mb-6" data-id="element-113">
                <Droplet className="w-7 h-7 text-blue-600" data-id="element-114" />
              </div>
              <h3 className="text-xl font-bold text-brand-teal mb-2" data-id="element-115">
                Pilar 1: Hidratación Energética
              </h3>
              <p className="text-gray-600" data-id="element-116">
                Usamos{' '}
                <strong className="text-brand-dark" data-id="element-117">
                  Agua de Mar Isotónica
                </strong>{' '}
                para devolver la conductividad eléctrica a las neuronas. Sin
                minerales correctos, el cerebro no puede transmitir señales de
                calma.
              </p>
            </div>
          </div>

          {/* Pillar 2 */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-md transition-shadow relative overflow-hidden" data-id="element-118">
            <div className="absolute top-0 right-0 w-24 h-24 bg-brand-light rounded-bl-full -z-0" data-id="element-119"></div>
            <div className="relative z-10" data-id="element-120">
              <div className="w-14 h-14 bg-brand-light rounded-xl flex items-center justify-center mb-6 border border-brand-gold/30" data-id="element-121">
                <ShieldCheck className="w-7 h-7 text-brand-gold" data-id="element-122" />
              </div>
              <h3 className="text-xl font-bold text-brand-teal mb-2" data-id="element-123">
                Pilar 2: El Aliado Invencible
              </h3>
              <p className="text-gray-600" data-id="element-124">
                El{' '}
                <strong className="text-brand-dark" data-id="element-125">
                  Aceite de Coco Alimenticio
                </strong>{' '}
                para barrer hongos como la Cándida y bacterias patógenas que
                secuestran el intestino y alteran el comportamiento.
              </p>
            </div>
          </div>

          {/* Pillar 3 */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-md transition-shadow relative overflow-hidden" data-id="element-126">
            <div className="absolute top-0 right-0 w-24 h-24 bg-green-50 rounded-bl-full -z-0" data-id="element-127"></div>
            <div className="relative z-10" data-id="element-128">
              <div className="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center mb-6" data-id="element-129">
                <Leaf className="w-7 h-7 text-green-600" data-id="element-130" />
              </div>
              <h3 className="text-xl font-bold text-brand-teal mb-2" data-id="element-131">
                Pilar 3: Quelación Verde
              </h3>
              <p className="text-gray-600" data-id="element-132">
                Protocolo 5x5 de Ludwig Johnson (
                <strong className="text-brand-dark" data-id="element-133">
                  Zanahoria en extractor
                </strong>
                ) para sacar el mercurio y plomo del sistema de forma natural y
                segura.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}